import React from "react";
import {
    Flex
} from "@chakra-ui/react";

import "../styles/card.css";


export default function Card(props) {
    const { className = "", ...rest } = props;

    return (
        <Flex className={"card " + className} {...rest}>
            {props.children}
        </Flex>
    );
}
